import React, { Component } from 'react';
import { get } from '../services/api';
import Loading from './Loading/Loading';
import PowerfulTable from './PowerfulTable/PowerfulTable';

export default class SubscriptionsList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      subscriptions: props.subscriptions || null,
      filteredSubscriptions: props.subscriptions || null,
      filter: '',
      showCreated: props.showAll || false
    };
  }

  componentDidMount() {
    if (!this.props.subscriptions) {
      this.fetchSubscriptions();
    }
  }

  fetchSubscriptions = async () => {
    // 1. Initial load
    const initialSubscriptions = await get(`/admin/subscriptions?limit=50`);
    if (initialSubscriptions) {
      this.setState({
        subscriptions: initialSubscriptions,
        filteredSubscriptions: initialSubscriptions,
        filter: ''
      });
    }

    // 2. Background load
    get(`/admin/subscriptions?limit=10000&skip=50`).then(rest => {
      if (rest && rest.length > 0) {
        this.setState(prevState => {
          const existingIds = new Set((prevState.subscriptions || []).map(s => s.subscriptionId));
          const newUnique = rest.filter(s => !existingIds.has(s.subscriptionId));
          const all = [...(prevState.subscriptions || []), ...newUnique];
          return {
            subscriptions: all,
            filteredSubscriptions: all
          };
        }, () => {
          if (this.state.filter) {
            this.applyFilter(this.state.filter);
          }
        });
      }
    });
  }

  applyFilter = (term) => {
    const s = term.toLowerCase();
    const filteredSubscriptions = this.state.subscriptions.filter((p) => {
      const searchStr = (p.subscriptionId + (p.pupil || '') + (p.status || '')).toLowerCase();
      return searchStr.includes(s);
    });
    this.setState({ filteredSubscriptions });
  }

  filter = (event) => {
    const s = event.target.value;
    this.setState({ filter: s });
    this.applyFilter(s);
  }

  render() {
    const { filteredSubscriptions, filter, showCreated } = this.state;
    if (!filteredSubscriptions) return <Loading />;

    const dataToDisplay = filteredSubscriptions.filter(p => (p.status !== 'PENDING' || showCreated));

    return (
      <div style={{ marginLeft: 20 }}>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
          <h2>Abonnements ({dataToDisplay.length})</h2>
          <div>
            <label style={{ marginRight: 5 }}>Afficher les paiements en attente</label>
            <input type='checkbox' checked={showCreated} onChange={(e) => this.setState({ showCreated: e.target.checked })} />
          </div>
          <div style={{ marginRight: 50 }}>
            <input
              placeholder='Filtrer...'
              type='text'
              onChange={this.filter}
              value={filter}
              style={{ paddingLeft: 10, width: 180, height: 30, borderRadius: 30, boxShadow: 'none', borderStyle: 'hidden', backgroundColor: '#eee', outline: 'none' }}
            />
          </div>
        </div>

        <PowerfulTable
          data={dataToDisplay}
          types={this.props.types || {
            subscriptionId: { name: 'id' },
            pupil: { name: 'élève' },
            amount: { name: 'montant (€)' },
            status: { name: 'statut' },
            createdOn: { name: 'date' },
            stripeSubscriptionId: { name: 'Stripe' },
          }}
          redirect={'subscriptions'}
          redirectKey={'subscriptionId'}
        />
      </div>
    );
  }
}
